import { useEffect, useMemo, useRef, useState } from 'react'
import MemberCerification from '../models/MemberCertification'
import MobTable from '../components/MobTable'
import { Button, Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { QRCode } from 'react-qrcode-logo'
import Member from '../models/Member'
export default function CertificatePage() {
    const [certificateData, setCertificateData] = useState([])
    const [profileData, setProfileData] = useState({})
    const qrRef = useRef(null)
    const initializeCertificate = async () => {
        try {
            let result = await MemberCerification.selfCertification()
            console.log('isinya', result)
            setCertificateData(result)
        } catch (e) {}
    }

    const fetchSelfData = async () => {
        let memberModel = new Member()
        try {
            let result = await memberModel.getMemberData()

            setProfileData(result)

            console.log('PROF PROFILE', result)
            console.log('PROF PROFILE', profileData?.member?.hpi_id)
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    const getMemberResultUrl = (token) => {
        const baseUrl = process.env.REACT_QR_CODE_BASE_URL || 'https://sihapei.hpi.or.id'
        return `${baseUrl}/qr-certificate/${token}`
    }

    useEffect(() => {
        initializeCertificate()
        fetchSelfData()
    }, [])

    const columns = useMemo(() => {
        let cols = [
            {
                Header: <p style={{ fontSize: '0.7em' }}>Nomor Sertifikat</p>,
                accessor: 'certification_number',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return <p style={{ fontSize: '0.7em' }}>{value?.certification_number}</p>
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Tipe Sertifikat</p>,
                accessor: 'certification_type',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return <p style={{ fontSize: '0.7em' }}>{value?.certification_type}</p>
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Penyelenggara</p>,
                accessor: 'certification_organization',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return <p style={{ fontSize: '0.7em' }}>{value?.certification_organization}</p>
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Berlaku Dari</p>,
                accessor: 'valid_from',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    if (value.valid_from == null) {
                        return <p style={{ fontSize: '0.7em' }}>-</p>
                    } else {
                        return (
                            <p style={{ fontSize: '0.7em' }}>
                                {moment(value?.valid_from).format('DD MMM YYYY')}
                            </p>
                        )
                    }
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Berlaku Sampai</p>,
                accessor: 'valid_until',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    if(Boolean(cellInfo.row.original.no_expiry) === true) {
                        return <p style={{ fontSize: '0.7em' }}>Selamanya</p>
                    } else if (value.valid_until == null) {
                        return <p style={{ fontSize: '0.7em' }}>-</p>
                    } else {
                        return (
                            <p style={{ fontSize: '0.7em' }}>
                                {moment(value?.valid_until).format('DD MMM YYYY')}
                            </p>
                        )
                    }
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Aksi</p>,
                accessor: 'token',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    if (value.token == null) {
                        return <p style={{ fontSize: '0.7em' }}>-</p>
                    } else {
                        return (
                            <div style={{display: 'flex', flexDirection: 'row', gap: 3}}>
                                <Button variant="outline-dark" onClick={() => window.location.replace(`/qr-certificate/${value.token}`)}>Lihat</Button>
                                <Button
                                    onClick={() => {
                                        try {
                                            if (!qrRef.current) {
                                                console.error('QR code container not available')
                                                return
                                            }

                                            const canvasElement =
                                                qrRef.current.querySelector('canvas')

                                            const size = 300
                                            const downloadCanvas = document.createElement('canvas')
                                            downloadCanvas.width = size
                                            downloadCanvas.height = size

                                            const context = downloadCanvas.getContext('2d')
                                            if (!context) {
                                                console.error('check isi context', context)
                                                return
                                            }
                                            context.fillStyle = 'white'
                                            context.fillRect(0, 0, size, size)
                                            context.drawImage(canvasElement, 0, 0, size, size)
                                            try {
                                                const pngUrl = downloadCanvas.toDataURL('image/png')
                                                const link = document.createElement('a')
                                                const fileName = `${value.token}.png`

                                                link.download = fileName
                                                link.href = pngUrl
                                                link.click()
                                            } catch (e) {
                                                console.error('Error creating download link:', e)
                                            }
                                        } catch (error) {
                                            console.error('Download failed:', error)
                                        }
                                    }}
                                >
                                    Unduh QR
                                </Button>

                                <div style={{ display: 'none' }} ref={qrRef}>
                                    <QRCode
                                        qrStyle={'square'}
                                        fgColor="#000000"
                                        logoPaddingStyle={'circle'}
                                        logoOpacity={0.8}
                                        logoPadding={0}
                                        removeQrCodeBehindLogo={true}
                                        logoWidth={140}
                                        value={getMemberResultUrl(value?.token)}
                                        size={300}
                                        ecLevel="H"
                                    />
                                </div>
                            </div>
                        )
                    }
                },
            },
        ]
        return cols
    })
    return (
        <>
            <Row style={{ marginBottom: 15 }}>
                <Col>
                    {certificateData?.length > 0 ? (
                        <MobTable
                            columns={columns}
                            data={certificateData}
                            interactionsLabelStyles={{ fontSize: '0.7em' }}
                        />
                    ) : (
                        'Anda belum memiliki sertifikat.'
                    )}
                </Col>
            </Row>
        </>
    )
}
